import { ChangeDetectionStrategy, Component, inject} from '@angular/core';
import { AbstractFormComponent, FieldTextComponent, FieldNumberComponent, FieldTextAreaComponent, FieldDateComponent, FieldSelectComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { EtiquetteStoreService } from '../../services/etiquette-service/etiquette-store.service';
import { WalletListComponent } from "../../components/wallet-list/wallet-list";
import { EtiquetteListComponent } from "../../components/etiquette-list/etiquette-list";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-trade-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonModule, FormsModule, FieldTextComponent, FieldTextAreaComponent, FieldSelectComponent, FieldNumberComponent, FieldDateComponent, WalletListComponent, EtiquetteListComponent],
  templateUrl: './trade-form.html'
})

export class TradeFormComponent extends AbstractFormComponent{
  public readonly walletStoreService = inject(WalletStoreService);
  public readonly etiquetteStoreService = inject(EtiquetteStoreService);
  

  public tradeTypeList = [
    {id: 1, shortDescription: "Entrata"},
    {id: 2, shortDescription: "Uscita"},
    {id: 3, shortDescription: "Giroconto"},
    {id: 4, shortDescription: "Investimento"},
    {id: 5, shortDescription: "Base"}
  ];

  public sourceTypeList = [
    {id: 1, shortDescription: "Manuale"},
    {id: 2, shortDescription: "Sistema"},
    {id: 3, shortDescription: "Import"}
  ];

}
  

